export const PageHeader = ({ eyebrow, title, subtitle, actions, brand }) => (
  <div className="rise-in flex flex-wrap items-end justify-between gap-4">
    <div className="min-w-0">
      {eyebrow && <div className="mb-1 text-[11px] font-semibold uppercase tracking-[0.16em] text-teal-700" data-testid="page-eyebrow">{eyebrow}</div>}
      <h1 className="text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl" data-testid="page-title">{title}</h1>
      {subtitle && <p className="mt-1 text-sm text-slate-500" data-testid="page-subtitle">{subtitle}</p>}
    </div>
    {actions && <div className="flex items-center gap-2">{actions}</div>}
  </div>
);
